import { es, pt, enUS } from 'date-fns/locale';
export const LOCALES: Object = { es, pt, enUS };
import localeCo from '@angular/common/locales/es-CO';
import localeMX from '@angular/common/locales/es-MX';
import localePt from '@angular/common/locales/pt';
import localeAR from '@angular/common/locales/es-AR';
import localePE from '@angular/common/locales/es-PE';
import localeEC from '@angular/common/locales/es-EC';
import localeUY from '@angular/common/locales/es-UY';
import localeCL from '@angular/common/locales/es-CL';

import { environment as ENV } from '@environment';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function getLocale(): any {
  switch (ENV.countryInfo.locale) {
    case ENV.available_locales.br:
      return localePt;
    case ENV.available_locales.co:
      return localeCo;
    case ENV.available_locales.mx:
      return localeMX;
    case ENV.available_locales.ar:
      return localeAR;
    case ENV.available_locales.pe:
      return localePE;
    case ENV.available_locales.cl:
      return localeCL;
    case ENV.available_locales.uy:
      return localeUY;
    case ENV.available_locales.ec:
      return localeEC;
    default:
      return localeCo;
  }
}
